import { render, staticRenderFns } from "./print_template_edit.vue?vue&type=template&id=483061bc&scoped=true"
import script from "./print_template_edit.vue?vue&type=script&lang=js"
export * from "./print_template_edit.vue?vue&type=script&lang=js"
import style0 from "./print_template_edit.vue?vue&type=style&index=0&id=483061bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483061bc",
  null
  
)

export default component.exports